export default __webpack_public_path__ + "static/media/NotoSans-Regular.a50ccd7e.ttf";